// 🔴 SECURITY (Wave 1B, 2026-04-29) — settings 파일 인증 다운로드 React hook
// fetchSettingsFileBlob (Wave 1A) 재사용 + URL.revokeObjectURL cleanup 자동.
//
// 사용:
//   var sig = useSettingsFile('signature', companyId);
//   <img src={sig.url} />   // sig.url 은 blob: URL (또는 null — 미로드/에러)
//   sig.refresh();          // 업로드/삭제 후 강제 재fetch
//
// 주의:
//   - companyId 변경 시 자동 재fetch + 이전 blob revoke
//   - 컴포넌트 unmount 시 cleanup 으로 revoke
//   - companyId 가 falsy 이면 fetch 스킵 → url=null
//   - 에러 시 url=null (빈 칸 허용 — img 미렌더 OK)
//   - refresh() 호출 시 nonce 변경 → useEffect 재실행 (이전 blob revoke + 새 fetch)
//
// type: 'signature' / 'stamp' / 'business-license'

import { useState, useEffect, useCallback } from 'react';
import { fetchSettingsFileBlob } from './settingsFileUrl';

function useSettingsFile(type, companyId) {
  var stateInit = { url: null, loading: false, error: null };
  var ret = useState(stateInit);
  var state = ret[0];
  var setState = ret[1];
  var nonceRet = useState(0);
  var nonce = nonceRet[0];
  var setNonce = nonceRet[1];

  useEffect(function() {
    if (!companyId) {
      setState({ url: null, loading: false, error: null });
      return undefined;
    }
    var cancelled = false;
    var createdUrl = null;
    setState({ url: null, loading: true, error: null });
    fetchSettingsFileBlob(type, companyId).then(function(blobUrl) {
      if (cancelled) {
        // race: fetch 완료 시점에 이미 unmount/dep 변경 → 즉시 revoke
        try { URL.revokeObjectURL(blobUrl); } catch (e) {}
        return;
      }
      createdUrl = blobUrl;
      setState({ url: blobUrl, loading: false, error: null });
    }).catch(function(err) {
      if (cancelled) return;
      setState({ url: null, loading: false, error: err });
    });
    return function cleanup() {
      cancelled = true;
      if (createdUrl) {
        try { URL.revokeObjectURL(createdUrl); } catch (e) {}
      }
    };
  }, [type, companyId, nonce]);

  var refresh = useCallback(function() { setNonce(function(n) { return n + 1; }); }, []);

  return { url: state.url, loading: state.loading, error: state.error, refresh: refresh };
}

export default useSettingsFile;
export { useSettingsFile };
